<template>
  <div class="min-h-screen w-full flex justify-center items-start p-6">
    <div class="w-full bg-white rounded-lg shadow-lg overflow-hidden">
      <!-- Scrollable content area -->
      <div class="max-h-[calc(100vh-3rem)] overflow-y-auto px-6 py-12">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>

        <p class="text-gray-700 mb-6">
          This privacy policy explains how we collect, use, and protect any
          information you provide when using our platform.
        </p>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Information We Collect
          </h2>
          <ul class="list-disc list-inside text-gray-700 space-y-1 mb-6">
            <li>Your name and contact details</li>
            <li>Demographic information</li>
            <li>Other information relevant to customer experience</li>
            <li>
              Data collected from third-party services like Facebook (if
              applicable)
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            How We Use Your Information
          </h2>
          <ul class="list-disc list-inside text-gray-700 space-y-1 mb-6">
            <li>To improve our services and customer support</li>
            <li>To send promotional offers (if you opt-in)</li>
            <li>For internal analytics and market research</li>
            <li>
              To personalize user experience through Facebook integrations (if
              applicable)
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Facebook Data Usage
          </h2>
          <p class="text-gray-700 mb-6">
            If you connect your account using Facebook Login, we may collect
            publicly available profile information such as your name, email, and
            profile picture. This data is used solely to provide account access
            and enhance user experience.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Facebook Tracking & Cookies
          </h2>
          <p class="text-gray-700 mb-6">
            We may use Facebook Pixel and other tracking technologies to analyze
            website traffic, measure ad performance, and improve our services.
            You can manage your preferences by adjusting your Facebook privacy
            settings or browser settings.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">Security</h2>
          <p class="text-gray-700 mb-6">
            We implement strong security measures to protect your personal
            information from unauthorized access or disclosure.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">Cookies</h2>
          <p class="text-gray-700 mb-6">
            We use cookies to enhance user experience. You can manage your
            cookie preferences in your browser settings.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Third-Party Links
          </h2>
          <p class="text-gray-700 mb-6">
            Our website may contain links to external sites. We are not
            responsible for their privacy practices.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">Your Rights</h2>
          <p class="text-gray-700 mb-4">You have the right to:</p>
          <ul class="list-disc list-inside text-gray-700 space-y-1 mb-6">
            <li>Request access to the data we hold about you</li>
            <li>Correct any inaccuracies in your personal data</li>
            <li>Request deletion of your personal data</li>
            <li>
              Revoke Facebook permissions and delete Facebook-associated data
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">Contact Us</h2>
          <p class="text-gray-700">
            If you have any questions regarding this privacy policy, you can
            reach us at:
          </p>
          <p class="text-gray-700 font-medium mt-2">
            📧 Email:
            <a
              href="mailto:support@tryhisell.com"
              class="text-blue-600 hover:underline"
              >support@tryhisell.com</a
            >
          </p>
        </section>

        <p class="text-gray-500 text-sm mt-8">Last updated: March 2025</p>
      </div>
    </div>
  </div>
</template>
